<div class="full-width ranger-slider">
  <mat-slider
    [color]="minColor"
    [displayWith]="formatLabel"
    [max]="max"
    [min]="min"
    discrete
    class="full-width cdk-focused slider-over slider-min-value"
    step="1"
  >
    <input
      matSliderThumb
      [(ngModel)]="minValue"
      (valueChange)="onMinValueChange($event)"
    />
  </mat-slider>
  <mat-slider
    [color]="maxColor"
    [displayWith]="formatLabel"
    [max]="max"
    [min]="min"
    discrete
    class="full-width cdk-focused slider-over slider-max-value"
    step="1"
  >
    <input
      matSliderThumb
      [(ngModel)]="maxValue"
      (valueChange)="onMaxValueChange($event)"
    />
  </mat-slider>
  <div class="full-width slider-over slider-line-cover-wrapper">
    <mat-divider
      [class]="isMinValueInit ? 'slider-line-cover-init' : 'slider-line-cover'"
    ></mat-divider>
    <mat-divider
      [class]="isMaxValueInit ? 'slider-line-cover-init' : 'slider-line-cover'"
    ></mat-divider>
  </div>

  @if (showRuler) {
    <div class="outer">
      <div class="middle">
        @for (key of rulerArray; track key) {
          <div class="inner">|</div>
        }
      </div>
      <div class="middle">
        @for (key of rulerArray; track key) {
          <div class="inner">
            <span>{{ key }}</span>
          </div>
        }
      </div>
    </div>
  }
</div>
